package com.trevorwiebe.timesheet.admin.locations.presentation

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Close
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlin.math.roundToLong

/**
 * Coordinate section of the add/edit location dialog. Android shows a
 * "set pin on map" flow; web geocodes the address without a map.
 */
@Composable
expect fun LocationCoordinateControls(
    form: LocationFormState,
    isGeocoding: Boolean,
    geocodeError: String?,
    onEvent: (LocationsEvent) -> Unit
)

/**
 * Full-screen map pin picker, rendered as a sibling of the add/edit dialog.
 * Only Android shows a map; the js actual is a no-op.
 */
@Composable
expect fun LocationMapPickerHost(
    visible: Boolean,
    latitude: Double?,
    longitude: Double?,
    onConfirm: (latitude: Double, longitude: Double) -> Unit,
    onDismiss: () -> Unit
)

internal fun formatCoordinates(latitude: Double, longitude: Double): String {
    fun fmt(v: Double) = ((v * 100000).roundToLong() / 100000.0).toString()
    return "${fmt(latitude)}, ${fmt(longitude)}"
}

/** Coordinates in a tertiary-colored pill with an inline clear (X) affordance. */
@Composable
internal fun CoordinatePill(
    latitude: Double,
    longitude: Double,
    onClear: () -> Unit
) {
    Row(
        modifier = Modifier
            .clip(RoundedCornerShape(50))
            .background(MaterialTheme.colorScheme.tertiary)
            .padding(start = 12.dp, end = 8.dp, top = 6.dp, bottom = 6.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = formatCoordinates(latitude, longitude),
            fontSize = 13.sp,
            color = MaterialTheme.colorScheme.onTertiary
        )
        Spacer(modifier = Modifier.width(6.dp))
        Icon(
            imageVector = Icons.Default.Close,
            contentDescription = "Clear coordinates",
            tint = MaterialTheme.colorScheme.onTertiary,
            modifier = Modifier
                .size(16.dp)
                .clickable(onClick = onClear)
        )
    }
}
